<app-loading-shadow aria-hidden="true" class="loading-offers" *ngIf="isLoading"></app-loading-shadow>
<div class="card-complete-flight" *ngIf="!isLoading">
    <div class="card-complete-flight__img" [style.background-image]="'url(' + image + ')'"></div>
    <div class="card-complete-flight__top">
        <h3 class="card-complete-flight__title" [innerHTML]="(title | ibeadmin | async)" *ngIf="subtitle"></h3>
        <h3 class="card-complete-flight__title" [innerHTML]="(title | ibeadmin | async)" *ngIf="!subtitle"></h3>
        <p class="card-complete-flight__sub-title" [innerHTML]="(subtitle | ibeadmin | async)" *ngIf="subtitle"></p>
    </div>
    <div class="card-complete-flight__bottom">
        <div class="card-complete-flight__disclaimer" *ngIf="extra">
            <p class="card-complete-flight__disclaimer-label">
                {{ name | ibeadmin | async }}
            </p>
            <p class="card-complete-flight__disclaimer-price">
                <ng-container *ngIf="!isAdded">
                    {{ 'review.cardOffer.text.' + extraDescription | ibeadmin | async }} {{price}}
                </ng-container>
                <ng-container *ngIf="isAdded">
                    {{'review.cardOffer.text.added' | ibeadmin | async}}
                </ng-container>
            </p>
        </div>
        <div class="card-complete-flight__disclaimer" *ngIf="!extra && logo">
            <app-svg class="card-complete-flight__disclaimer-logo {{logo.class}}" aria-hidde="true" aria-label="Offer logo" [svg]="logo.svg"></app-svg>
        </div>

        <div class="card-complete-flight__button-wrapper">
            <button class="button button-accent button--small" (click)="INDRA_openExtra()" [attr.aria-label]="('review.cardExtras.text.add' | ibeadmin | async) + ' ' + (name | ibeadmin | async)" *ngIf="!isAdded && !externalLink">
				{{ extra.action.label | ibeadmin | async }}
			</button>
            <button class="button button--small" (click)="INDRA_openExtra()" [attr.aria-label]="('review.cardExtras.text.edit' | ibeadmin | async) + ' ' + (name | ibeadmin | async)" *ngIf="isAdded  && !externalLink">
				{{'review.cardExtras.text.edit' | ibeadmin | async}}
			</button>
            <a class="button button--small button--icon-right" tabindex="0" href="javascript:;" title="Opens new window" role="button" [attr.href]="externalLink.url" target="_blank" *ngIf="externalLink">
				{{ externalLink.label }}
				<app-svg svg="icons.svg#interface--external_link" [alt]="'External link icon'" aria-hidden=true></app-svg>
			</a>
        </div>
    </div>
</div>